import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const DLCTUnverifiedApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Unverified Applications(DLCT)"
        status={[applicationStatusMap?.dlctUnverified.value]}
        stage={[]}
      />
    </DashboardLayout>
  );
};

export default DLCTUnverifiedApplications;
